var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"clearable":"","items":_vm.xeroRepeatingInvoices,"return-object":true,"item-text":i =>
    `${_vm.formatDate(i.date)}: ${i.reference} - ${_vm.formatNumber(i.total)}`,"label":"Reference"},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }